export type TurnitinEulaLanguage =
  | 'sv-SE'
  | 'zh-CN'
  | 'ja-JP'
  | 'ko-KR'
  | 'es-MX'
  | 'nl-NL'
  | 'ru-RU'
  | 'zh-TW'
  | 'ar-SA'
  | 'pt-BR'
  | 'de-DE'
  | 'el-GR'
  | 'nb-NO'
  | 'cs-CZ'
  | 'da-DK'
  | 'tr-TR'
  | 'pl-PL'
  | 'fi-FI'
  | 'it-IT'
  | 'vi-VN'
  | 'fr-FR'
  | 'en-US'
  | 'ro-RO';

export interface ITurnitinEulaInfoRequest {
  lang?: TurnitinEulaLanguage;
}

export interface ITurnitinEulaInfoResponse {
  version: string;
  url: string;
  required: boolean;
}

export interface ITurnitinEulaPageRequest {
  lang?: TurnitinEulaLanguage;
}

export interface ITurnitinEulaAcceptRequest {
  language: TurnitinEulaLanguage;
}

export interface ITurnitinEulaAcceptResponse {
  accepted: boolean;
  version: string;
  acceptedAt: string;
  language: TurnitinEulaLanguage;
  turnitinResponse: Record<string, unknown>;
}

export interface ITurnitinEulaStatusResponse {
  accepted: boolean;
  version: string;
  acceptedAt: string;
  language: TurnitinEulaLanguage;
}

export enum TurnitinSubmissionStatus {
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export type ITurnitinViewerRequest = number;

export interface ITurnitinViewerResponse {
  viewerUrl: string;
}
